import axios from 'axios';
import { message } from 'antd';
import {
  INVENTORY_API
} from '../../../constants/API';
import {
  SEND_WITHDRAWAL_TRANSFERED
} from '../types';


function sendWithdrawalTransfered(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: SEND_WITHDRAWAL_TRANSFERED,
        sendingWithdrawalTransfered: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const inviteResponse = await axios.post(`${INVENTORY_API}/sendWithdrawalTransfered`, data, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        if(inviteResponse.data.isError) {
          message.error('Error sending consigner notification');
        } else {
          message.success('Sent Consigner Notifications')
        }
        dispatch({
          type: SEND_WITHDRAWAL_TRANSFERED,
          sendingWithdrawalTransfered: false
        });
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: SEND_WITHDRAWAL_TRANSFERED,
          sendingWithdrawalTransfered: false
        });
        console.log(e);
      }
  }
}
export default sendWithdrawalTransfered;
